export enum ToDoTypeEnum {
    CERTIFICATE_TO_DO = 1,
    MODULE_TO_DO = 2,
    SURVEY_TO_DO = 3,
    QUIZ_TO_DO = 4,
    PERSONAL_REVIEW_TO_DO = 5,
    TEAM_REVIEW_TO_DO = 6,
    APPROVAL_REQUEST_TO_DO = 7,
}
